import React from "react";
import PrivacyPolicy from "../../PicesForPages/PrivacyPolicy.webp";
import FreeConsultation from "../Form/FreeConsultation";

function PrivacyPolicyStatement() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={PrivacyPolicy}
          alt="tlpImage"
          className="background-video PrivacyPolicyImage"
        />
        <div className="purchasetopBox">
          <span>Privacy Statement</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          {/* <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">
              Collection of Information
            </span>
            <span className="purchaseBottomLeftContent">
              Unless explicitly provided for inquiries or service registration,
              this website collects only non-personal data, including your
              server address, access date and time, pages visited, documents
              downloaded, referring site, and browser type. This information is
              used solely for statistical analysis and to improve site
              functionality.
            </span>

            <span className="purchaseBottomLeftHeader">
              Collection by Authorized Personnel
            </span>
            <span className="purchaseBottomLeftContent">
              When personal details are requested, they are collected
              exclusively by authorized personnel of{" "}
              <span className="logoBoldColor">The Mortgageist</span> for the
              specific purpose of responding to your inquiry or administering
              your service registration.
            </span>

            <span className="purchaseBottomLeftHeader">
              Use of Personal Information
            </span>
            <span className="purchaseBottomLeftContent">
              By providing your email address and phone number, you consent to
              receiving communications from{" "}
              <span className="logoBoldColor">The Mortgageist</span> and to
              being added to our mailing list. Your privacy is of utmost
              importance; your information will not be shared with or sold to
              any third party. All communications will be relevant and limited
              to updates, services, or offerings of interest.
            </span>

            <span className="purchaseBottomLeftHeader">Cookies</span>
            <span className="purchaseBottomLeftContent">
              This website uses both persistent and session cookies. Persistent
              cookies remain on your device and may be used to facilitate
              tracking during return visits. Session cookies are temporary and
              are deleted upon closing your browser. No personal identifiers are
              retained after the session ends.
            </span>

            <span className="purchaseBottomLeftHeader">
              Disclosure of Information
            </span>
            <span className="purchaseBottomLeftContent">
              Personal information will be disclosed to third parties only if
              required by law or with your explicit consent.
            </span>

            <span className="purchaseBottomLeftHeader">Security</span>
            <span className="purchaseBottomLeftContent">
              While reasonable measures are employed to safeguard your data, the
              security of information transmitted over the internet cannot be
              guaranteed.
            </span>

            <span className="purchaseBottomLeftHeader">External Links</span>
            <span className="purchaseBottomLeftContent">
              Links to third-party websites are provided solely for your
              convenience.{" "}
              <span className="logoBoldColor">The Mortgageist</span> is not
              responsible for the privacy practices or security of these
              external sites.
            </span>

            <span className="purchaseBottomLeftHeader">Your Rights</span>
            <span className="purchaseBottomLeftContent">
              You may request access to your personal information and request
              corrections if necessary. No fees apply, except for any reasonable
              administrative processing costs.
            </span>

            <span className="purchaseBottomLeftHeader">Contact</span>
            <span className="purchaseBottomLeftContent">
              For any questions regarding this Privacy Statement, please contact
              us at{" "}
              <a
                href="mailto: Contact@TheMortgageist.com"
                style={{
                  textDecoration: "none",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                Contact@TheMortgageist.com
              </a>
              .
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://themortgageist.my1003app.com/2692605/register/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div> */}
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">Privacy Policy</span>
            <span className="purchaseBottomLeftContent">
              <b>Last Updated:</b> March 3, 2026
            </span>
            <span className="purchaseBottomLeftContent">
              <span className="logoBoldColor">The Mortgageist Inc.,</span>{" "}
              (“we,” “us,” or “our”) is committed to protecting your privacy.
              This Privacy Policy explains how we collect, use, and safeguard
              your information when you visit our website and use our mortgage
              services.
            </span>
            <ol className="purchaseBottomLeftBox purchaseBottomLeftBox00">
              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                Information Collection
              </li>
              <span className="purchaseBottomLeftContent">
                We collect personal information that you voluntarily provide to
                us when you express interest in obtaining information about
                mortgage products and services. This includes:
              </span>
              <ul className="purchaseBottomLeftContent purchaseBottomLeftContent00">
                <li>
                  <b>Contact Data: </b>Name, email address, and phone number.
                </li>
                <li>
                  <b>Financial Data: </b>Information provided for mortgage
                  pre-qualification and applications.
                </li>
                <li>
                  <b>Technical Data: </b>IP addresses and browser types used for
                  site analytics.
                </li>
              </ul>

              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                Use of Information
              </li>
              <span className="purchaseBottomLeftContent">
                We use the information collected to:
              </span>
              <ul className="purchaseBottomLeftContent purchaseBottomLeftContent00">
                <li>Provide and maintain our mortgage services.</li>
                <li>Process inquiries and loan applications.</li>{" "}
                <li>
                  Communicate updates regarding interest rates and loan status.
                </li>{" "}
                <li>Comply with legal and regulatory requirements.</li>
              </ul>

              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                SMS & Mobile Messaging Terms
              </li>
              <span className="purchaseBottomLeftContent">
                By providing your phone number and opting in via our website
                forms, you consent to receive recurring automated marketing and
                transactional text messages from{" "}
                <span className="logoBoldColor">The Mortgageist Inc.</span>
              </span>
              <ul className="purchaseBottomLeftContent purchaseBottomLeftContent00">
                <li>
                  <b>Consent: </b>Enrollment is strictly voluntary. Consent is
                  not a condition of purchase or loan approval.
                </li>
                <li>
                  <b>Opt-Out: </b>You can cancel the SMS service at any time by
                  texting <b>STOP</b> to <b>+1 (855) 526-2999</b>. You will
                  receive a one-time confirmation message.
                </li>
                <li>
                  <b>Support: </b>For assistance, reply <b>HELP</b> to our
                  toll-free number or contact us at{" "}
                  <b>Contact@TheMortgageist.com</b>.
                </li>
                <li>
                  <b>Frequency & Rates:</b> Message frequency varies based on
                  your interactions. Standard message and data rates may apply.
                </li>
              </ul>

              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                Third-Party Sharing & Privacy Guarantee
              </li>
              <span className="purchaseBottomLeftContent">
                <span className="logoBoldColor">The Mortgageist Inc.</span> does
                not sell, rent, or lease customer lists to third parties. Mobile
                information will not be shared with third parties or affiliates
                for marketing or promotional purposes. All the above categories
                exclude text messaging originator opt-in data and consent; this
                information will not be shared with any third parties.
              </span>

              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                Data Security
              </li>
              <span className="purchaseBottomLeftContent">
                We implement industry-standard security measures to safeguard
                your personal information. However, no method of transmission
                over the internet or electronic storage is 100% secure.
              </span>

              <li className="purchaseBottomLeftHeader purchaseBottomLeftHeader00">
                Contact Information
              </li>
              <span className="purchaseBottomLeftContentParent">
                <span className="purchaseBottomLeftContent">
                  {" "}
                  For questions regarding this Privacy Policy or our messaging
                  program, please contact us:
                </span>
                <span className="purchaseBottomLeftContent">
                  <span className="logoBoldColor">The Mortgageist Inc.</span>
                </span>
                <span className="purchaseBottomLeftContent">
                  134 John Robert Thomas Dr, 2nd Floor, Exton, PA 19341
                </span>
                <span className="purchaseBottomLeftContent">
                  <b>Email: </b>Contact@TheMortgageist.com
                </span>
                <span className="purchaseBottomLeftContent">
                  <b>Office Phone: </b>(610) 618-0618
                </span>
                <span className="purchaseBottomLeftContent">
                  <b>SMS Support: </b>+1 (855) 526-2999
                </span>
              </span>

              <div className="purchaseBottomLeftButton">
                <a
                  href="https://themortgageist.my1003app.com/2692605/register/"
                  target="_blank"
                  rel="noreferrer"
                  className="purchaseBottomLeftButtonLink"
                >
                  Apply Now
                </a>
              </div>
            </ol>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyStatement;
